var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#cont_main[data-v-7ea8d9a6]{background-image:url(" + escape(require("../assets/pictures/1.jpg")) + ");background-repeat:no-repeat;background-position:50%;background-size:cover;background-attachment:fixed}.img_cont[data-v-7ea8d9a6]{max-width:60%}.inputfile[data-v-7ea8d9a6]{width:.1px;height:.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}#file_loader[data-v-7ea8d9a6]{margin:0;padding:0;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ea8d9a6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/Maintenance.vue
// module id = 342
// module chunks = 0